import React, {useState} from 'react';
import PagesMenu from "./PagesMenu";
import styled from "styled-components";
import WorkPlace from "./WorkPlace";
import useStore from "../Store";
import SubPagesMenu from "./SubPagesMenu";

const MainDiv=styled.div`
    width: 98.7vw;
    height: 98vh;
    //border: 2px black solid;
    display:flex;
    flex-direction: column;    
`
const UnderRoofDiv=styled.div`    
    top: 0;
    left:0;
    width: 99%;
    height: 100%;
    display: inline-flex;
    //border: 2px yellow solid;
    @media (max-width: ${props=>props.ScreenWidth}) {
        display: block;
    }
`
const UpperMenuAndWorkPlaceDiv=styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    //border: 2px green solid;
`
const MainPage = () => {
    const selectedPage=useStore((state)=>state.selectedPage);
    const setSelectedPage=useStore((state)=>state.setSelectedPage);
    const ScreenWidthForMobile=useStore((state)=>state.ScreenWidthForMobile)
    const [selectedSubPage, setSelectedSubPage]=useState(0);
    return (
        <MainDiv>
            <UnderRoofDiv
                ScreenWidth={ScreenWidthForMobile}
            >
                <PagesMenu
                    selectedPage={selectedPage}
                    setSelectedPage={setSelectedPage}
                    setSelectedSubpage={setSelectedSubPage}
                />
                <UpperMenuAndWorkPlaceDiv>
                    {selectedPage?
                        <SubPagesMenu
                            selectedPage={selectedPage}
                            selectedSubPage={selectedSubPage}
                            setSelectedSubPage={setSelectedSubPage}
                        />
                        :""
                    }
                    <WorkPlace
                        selectedSubPage={selectedSubPage}
                        selectedPage={selectedPage}
                        setSelectedSubPage={setSelectedSubPage}
                    />
                </UpperMenuAndWorkPlaceDiv>
            </UnderRoofDiv>
        </MainDiv>
    );
};

export default MainPage;